<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>机构管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>机构配置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>机构配置</span>
        </div>
        <span class="xcx-add left font14" @click="reBack()">返回列表</span>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table
          border
          :data="tableData"
          stripe
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column prop="id" label="UID" width="60"></el-table-column>
          <el-table-column
            prop="title"
            label="名称"
            width="180"
          ></el-table-column>
          <el-table-column prop="desc" width="*"></el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="setStatus(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template #default="scope">
              <div class="doSonimg_box font14">
                <el-button
                  size="mini"
                  type="success"
                  @click="payment(scope.row)"
                  >参数配置</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination
            class="left"
            @current-change="handleCurrentChange"
            :current-page="page"
            background
            layout="prev, pager, next"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      id: "",
      page: 0,
      count: 0,
      limit: 10,
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    var query = that.$route.query;
    if (query.id) {
      that.id = query.id;
      that.getList();
    } else {
      that.loading = false;
    }
  },
  methods: {
    payment(row) {
      this.$router.push({
        path: row.urls,
        query: {
          uId: row.uId,
          id: row.id,
        },
      });
    },
    setStatus(row) {
      var that = this;
      that.axios
        .post("/setting/status", { id: row.id, status: row.status })
        .then((res) => {});
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.id = that.id;
      formData.page = that.page;
      formData.limit = that.limit;
      that.axios.post("setting/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
    reBack() {
      var that = this;
      that.$router.push({
        path: "/manage/index",
      });
    },
  },
};
</script>
<style>
</style>